import classNames from "classnames";
import { Link, LinkProps } from "react-router-dom";
import styles from "./StyledLink.module.css";

type Props = LinkProps;

export function StyledLink({ className, ...props }: Props) {
  return <Link {...props} className={classNames(styles.link, className)} />;
}
